import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** shadcn's class combiner — the standard `cn` helper. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
